import { AxiosResponse } from 'axios';
import { appContextDelete } from './httpCommon/appAxios.service';
import { CONFIGURATION_API_ENDPOINTS } from '../constants/apiEndpoints';

export const deactivateUserProfileById = (userId: number): Promise<AxiosResponse<{}, any>> => {
  return appContextDelete(CONFIGURATION_API_ENDPOINTS.DEACTIVATE_PROFILE + userId);
};
